import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../utils/unit-conversion';
import { amountType as amountTypeEnum, deductMode as deductModeEnum, repayStatus as repayStatusEnum, } from '../../enum/common';
import { contractRepaymentStatusClassName, contractRepaymentStatus, } from '../../enum/contract';
export default Vue.extend({
    name: 'contractRepaymentPlan',
    props: {
        contractCode: {
            type: String,
            default: '',
        },
    },
    computed: {
        statusTxt: function () {
            return contractRepaymentStatus[this.contractData.contractRepayStatus];
        },
        statusClassName: function () {
            var _a;
            var className = contractRepaymentStatusClassName[this.contractData.contractRepayStatus];
            return _a = {},
                _a[className] = true,
                _a;
        },
        baseClassName: function () {
            var _a;
            var className = contractRepaymentStatusClassName[this.contractData.contractRepayStatus];
            return _a = {},
                _a["base-" + className] = true,
                _a;
        },
        barClassName: function () {
            var _a;
            var className = contractRepaymentStatusClassName[this.contractData.contractRepayStatus];
            return _a = {},
                _a["bar-" + className] = true,
                _a;
        },
    },
    data: function () {
        return {
            contractData: null,
            pageSize: 40,
            pageNo: 1,
            repaymentList: null,
            totalItemCount: 0,
            repaymentListVisible: false,
            loadingMain: null,
        };
    },
    created: function () {
        this.openLoading();
        this.getContractData('hand');
        this.getRepaymentList('hand');
    },
    methods: {
        getClassName: function (_a) {
            var row = _a.row;
            var repayStatus = row.repayStatus;
            return repayStatus === 'PAID_OFF' ? 'paid-off' : '';
        },
        switchYuan: function (val) {
            return toYuan(val);
        },
        switchDate: function (val) {
            return moment(val).format('YYYY-MM-DD');
        },
        switchAmountType: function (_a) {
            var amountType = _a.amountType, amountTypeText = _a.amountTypeText;
            return amountTypeEnum[amountType] || amountTypeText || '--';
        },
        switchAmount: function (_a) {
            var amount = _a.amount;
            return this.switchYuan(amount).toFixed(2);
        },
        switchPaidAmount: function (_a) {
            var paidAmount = _a.paidAmount;
            return this.switchYuan(paidAmount).toFixed(2);
        },
        switchWaitAmout: function (_a) {
            var amount = _a.amount, paidAmount = _a.paidAmount;
            var waitAmout = amount - paidAmount;
            return this.switchYuan(waitAmout).toFixed(2);
        },
        switchTime: function (_a) {
            var startTime = _a.startTime, endTime = _a.endTime;
            return (startTime ? moment(startTime).format('YYYY-MM-DD') : '--') + " \u81F3 " + (endTime ? moment(endTime).format('YYYY-MM-DD') : '--');
        },
        switchDeduct: function (_a) {
            var deductMode = _a.deductMode;
            return deductModeEnum[deductMode];
        },
        switchRepayStatus: function (_a) {
            var repayStatus = _a.repayStatus;
            return repayStatusEnum[repayStatus];
        },
        openLoading: function () {
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
        },
        getContractData: function (loadingControl) {
            var _this = this;
            var contractCode = this.contractCode;
            this.$request({
                url: '/proxy/api/contract/get',
                method: 'post',
                loadingControl: loadingControl || 'auto',
                data: {
                    contractCode: contractCode,
                },
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode === 0) {
                    _this.contractData = res.data;
                }
            });
        },
        getRepaymentList: function (loadingControl) {
            var _this = this;
            var _a = this, contractCode = _a.contractCode, pageSize = _a.pageSize, pageNo = _a.pageNo;
            this.$request({
                url: '/proxy/api/plan/page',
                method: 'post',
                loadingControl: loadingControl || 'auto',
                data: {
                    pageSize: pageSize,
                    pageNo: pageNo,
                    contractCode: contractCode,
                },
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode === 0) {
                    _this.totalItemCount = res.totalItemCount;
                    _this.repaymentList = res.data;
                }
            });
        },
        currentChange: function (val) {
            this.pageNo = val;
            this.getRepaymentList();
        },
        createPlan: function () {
            var contractCode = this.contractCode;
            this.$router.push({
                name: 'repaymentImport',
                params: { contractCode: contractCode },
            });
        },
        closeDialog: function () {
            this.$emit('reset-dialog');
        },
    },
    watch: {
        contractData: function (val) {
            if (val !== null && this.repaymentList !== null) {
                this.repaymentListVisible = true;
                this.loadingMain && this.loadingMain.close();
                this.loadingMain = null;
                return;
            }
            this.repaymentListVisible = false;
        },
        repaymentList: function (val) {
            if (val !== null && this.contractData !== null) {
                this.repaymentListVisible = true;
                this.loadingMain && this.loadingMain.close();
                this.loadingMain = null;
                return;
            }
            this.repaymentListVisible = false;
        },
    },
});
